export function isSelfEmployed(taskWorker) {
  return !!taskWorker.worker && Number(taskWorker.worker.employment_type) === 1;
}

export function hasBalansResponse(taskWorker) {
  return ['applied', 'confirmed'].includes(taskWorker.balans_pro_response_status);
}

export function balansResponseLabel(taskWorker) {
  if (!isSelfEmployed(taskWorker)) return '—';
  return {
    applied: 'Откликнулся',
    confirmed: 'Закреплён за заданием',
    refused: 'Отказался',
    reserve: 'В резерве',
    rejected: 'Снят с задания',
    pending: 'Не откликнулся',
    not_sent: 'Задание не отправлено',
    unknown: 'Нет данных об отклике',
  }[taskWorker.balans_pro_response_status] || 'Нет данных об отклике';
}

export function balansPaymentBlockReason(taskWorker) {
  if (!isSelfEmployed(taskWorker) || hasBalansResponse(taskWorker)) return '';
  if (taskWorker.balans_pro_response_status === 'not_sent') {
    return 'Оплата недоступна: задание ещё не отправлено исполнителю в Баланс Про.';
  }
  if (taskWorker.balans_pro_response_status === 'pending') {
    return 'Оплата недоступна: исполнитель ещё не откликнулся на это задание в Баланс Про.';
  }
  if (['refused', 'reserve', 'rejected'].includes(taskWorker.balans_pro_response_status)) {
    return `Оплата недоступна: статус исполнителя в Баланс Про — «${balansResponseLabel(taskWorker)}».`;
  }
  return 'Оплата недоступна: отклик исполнителя на это задание в Баланс Про не подтверждён.';
}

export default {
  methods: {isSelfEmployed, balansResponseLabel, balansPaymentBlockReason},
};



// WEBPACK FOOTER //
// ./src/utilites/balansTaskResponse.js